// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__49GnH","title":"AfterBackImages_title__1LT9t","images":"AfterBackImages_images__2aWdi"};